"use client";
import Link from "next/link";
import Image from "next/image";
import { logo } from "@assets";
import { cn } from "@lib/utils";
import { useState } from "react";
import { pageLinks } from "@data";
import { Menu, X } from "lucide-react";
import { Button } from "@components/ui/button";
import { usePathname, useRouter } from "next/navigation";

const Navigation = () => {
	const router = useRouter();
	const pathname = usePathname();
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const isActiveLink = (href: string) => {
		if (href === "/") {
			return pathname === "/";
		}
		return pathname.startsWith(href);
	};

	return (
		<nav className="relative z-50 w-full px-4 sm:px-6 lg:px-8">
			<div className="mx-auto w-full max-w-7xl py-4">
				<div className="flex items-center justify-between">
					<div className="flex items-center justify-between">
						<Button aria-label="toggle-menu" className="hover:text-secondary transition-all duration-200 md:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)} size="icon" variant="ghost">
							{isMenuOpen ? <X /> : <Menu />}
						</Button>
						<Link href="/" onClick={() => setIsMenuOpen(false)}>
							<Image alt="Logo" className="h-auto w-24 sm:w-32 lg:w-40" priority src={logo} />
						</Link>
					</div>
					<div className="flex items-center justify-between gap-6">
						<div className="hidden items-center gap-6 md:flex">
							{pageLinks?.map(pageLink => (
								<Link className={cn("px-3 py-2 font-medium transition-all duration-200", isActiveLink(pageLink?.href) ? "text-foreground border-border border-b-2" : "hover:text-secondary hover:border-secondary text-muted-foreground hover:border-b-2")} href={pageLink?.href} key={pageLink?.uuid}>
									{pageLink?.label}
								</Link>
							))}
						</div>
						<Button className="rounded-full px-6 transition-all duration-200 hover:scale-105 hover:opacity-90" onClick={() => router.push("/auth/login")} variant="secondary">
							Login
						</Button>
					</div>
				</div>
				<div className={cn("transition-all duration-300 md:hidden", isMenuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0")}>
					<div className="flex flex-col justify-center gap-1 py-4">
						{pageLinks?.map(pageLink => (
							<Link
								className={cn("px-3 py-2 font-medium transition-all duration-200", isActiveLink(pageLink?.href) ? "text-foreground border-border border-l-4" : "hover:text-secondary hover:border-secondary text-muted-foreground hover:border-l-4")}
								href={pageLink?.href}
								key={pageLink?.uuid}
								onClick={() => setIsMenuOpen(false)}
							>
								{pageLink?.label}
							</Link>
						))}
					</div>
				</div>
			</div>
		</nav>
	);
};

export default Navigation;
